import { h, Component } from 'preact'
import styled from 'styled-components'

const StatementBlock = styled.div`
  q:before,
  q:after {
    content: '';
  }
  q {
    font-style: italic;
  }
  span {
    font-style: normal;
  }
`

export default class PoliticianStatement extends Component {
  render() {
    const { notes, signature, html } = this.props
    if (!notes && !html) return <div />

    return (
      <StatementBlock>
        <span>Vyjádření politika: </span>
        <q>
          {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : null}
          {notes || null}
          {signature ? <span> {signature}</span> : null}
        </q>
      </StatementBlock>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/politician/politician-statement.js